module.exports = __webpack_public_path__ + "static/media/punch-blast.6b4a7786.png";